<footer class="footer">
    <div class="w-100 clearfix">
       <span class="text-muted d-block text-center text-sm-left d-sm-inline-block">Copyright © 2021 <a href="https://irisgst.com/" target="_blank" class="iris-gst-link">irisgst.com</a>. All rights reserved.</span>           
    </div>
    <div align = "right">
      <a href="javascript:;" id="scrollToTop">&#x25B2;</a>
      </div>
 </footer>